
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// VML polyfill for Leaflet compatibility
// if (!document.namespaces) {
//   document.namespaces = {};
//   document.namespaces.add = function(name, urn) {
//     const element = document.createElement('div');
//     element.style.behavior = 'url(#default#VML)';
//     return element;
//   };
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);